import React from "react";
import styled from "@emotion/styled";
import PreviewSection from "../components/PreviewSection";
import {
  H1,
  H2,
  H3,
  H4,
  SubSectionHeader,
  Paragraph,
} from "@atlas-int/ui";
import {
  spacing,
  fontSize,
  fontFamily,
  fontWeight,
  border as borderToken,
  surface,
  text,
} from "@atlas-int/tokens";

const ExampleBlock = styled.div`
  margin-bottom: ${spacing[10]};
  padding: ${spacing[8]};
  background-color: ${surface.raised};
  border: 1px solid ${borderToken.subtle};
  border-radius: 4px;
`;

const Label = styled.span`
  display: inline-block;
  font-family: ${fontFamily.mono};
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.normal};
  color: ${text.muted};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: ${spacing[2]};
`;

const TypographySection: React.FC = () => {
  return (
    <PreviewSection
      id="typography"
      title="Typography"
      description="Shared heading and paragraph components from TextStyling.tsx. Used on landing, about, FAQ, glossary, and data pages."
    >
      <ExampleBlock>
        <Label>{"<H1>"}</Label>
        <H1 style={{ marginTop: 0 }}>Heading Level 1</H1>
      </ExampleBlock>

      <ExampleBlock>
        <Label>{"<H2>"}</Label>
        <H2 style={{ marginTop: 0 }}>Heading Level 2</H2>
      </ExampleBlock>

      <ExampleBlock>
        <Label>{"<H3>"}</Label>
        <H3 style={{ marginTop: 0 }}>Heading Level 3</H3>
      </ExampleBlock>

      <ExampleBlock>
        <Label>{"<H4>"}</Label>
        <H4>Heading Level 4</H4>
      </ExampleBlock>

      <ExampleBlock>
        <Label>{"<SubSectionHeader>"}</Label>
        <SubSectionHeader>Sub Section Header</SubSectionHeader>
      </ExampleBlock>

      <ExampleBlock>
        <Label>{"<Paragraph>"}</Label>
        <Paragraph>
          This is a standard paragraph component used across content pages. It
          provides consistent font size, line height, and color for body text
          throughout the application.
        </Paragraph>
      </ExampleBlock>
    </PreviewSection>
  );
};

export default TypographySection;
